import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { setToken } from "../../Components/utilities/authHelper";
import { decodeJWT } from "../Utils/Utils";
import { getPostSsoRedirectUrl } from "./glSsoTiles";

const GLSSOLogin = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { loginToken } = useParams();
  const location = useLocation();
  const [, setStatus] = useState("");
  const [, setIsLoading] = useState(true);
  const iframeName = window.name || "default";
  const originalUrl = sessionStorage.getItem(`start_page_${iframeName}`);
  const tileKey = new URLSearchParams(location.search).get("tile");

  useEffect(() => {
    const ssoLogin = async () => {
      if (!loginToken) {
        return;
      }

      try {
        setIsLoading(true);
        const response = await fetch(`${apiUrl}/sso/login?token=${loginToken}`);
        const data = await response.json();

        if (!response.ok) {
          setStatus("Login Failed Please Retry.");
          return;
        }

        if (data.results.access_token) {
          const payload = decodeJWT(data.results.access_token);
          setToken(
            data.results.access_token,
            data.results.user_id,
            data.results.role,
            payload.account_id
          );
        }
        window.location.href = getPostSsoRedirectUrl({
          tileKey,
          originalUrl,
        });
      } catch (error) {
        setStatus("Login Failed Please Retry.");
      } finally {
        setIsLoading(false);
      }
    };

    ssoLogin();
  }, [apiUrl, loginToken, originalUrl, tileKey]);

  return (
    <div>
      <h2>Logging in...</h2>
    </div>
  );
};

export default GLSSOLogin;
